var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{name: 'docs', params: {chapter: 'metric-exporters', group: _vm.exporter, item: 'metrics' }, hash:`#${_vm.name}`}}},[(_vm.alias)?_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.alias))]):_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }